/* eslint-disable react/require-default-props,react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import { confirmable } from 'react-confirm';
import classnames from 'classnames';
import { ModalDialog } from '../ModalDialog';
import './Confirm.scss';

const ConfirmDialog_ = (props) => {
  const { show, proceed, confirmation, options, cancel } = props;
  const actions = [
    { label: options.okLabel || 'OK', onClick: proceed, type: 'default' },
  ];
  const title = options.title || 'Confirm';
  const { dialogClassName } = options;

  if (options.cancelLabel) {
    actions.push({
      label: options.cancelLabel,
      onClick: cancel,
      type: 'default',
    });
  }

  return (
    <ModalDialog
      {...{ show, title, actions }}
      onHide={cancel}
      dialogClassName={classnames('react-confirm-dialog', dialogClassName)}
    >
      {confirmation}
    </ModalDialog>
  );
};

ConfirmDialog_.propTypes = {
  show: PropTypes.bool,
  proceed: PropTypes.func,
  cancel: PropTypes.func,
  confirmation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.object,
};

export const ConfirmDialog = confirmable(ConfirmDialog_);
